import { Link } from "react-router-dom";
import { genres } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="border-t border-primary-100 bg-primary-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg w-[18px] h-[18px] flex items-center justify-center" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                蜜桃成熟时在线观看
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注于高清影片整理与在线观看体验的影视内容平台。按类型、地区、年份快速筛选，随时找到今晚想看的那一部。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-information-line text-sm w-4 h-4 flex items-center justify-center text-primary-600" />
              站内影片资料与封面均为演示素材，播放区域为前端演示，不提供真实片源。
            </p>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/category", label: "电影分类" },
                { to: "/search", label: "搜索结果" },
                { to: "/about", label: "关于与联系" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="whitespace-nowrap text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
              热门类型
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {genres.slice(0, 6).map((genre) => (
                <Link
                  key={genre.name}
                  to={`/category?type=${encodeURIComponent(genre.name)}`}
                  className="whitespace-nowrap rounded-full border border-primary-200/70 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
                >
                  {genre.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-200/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蜜桃成熟时在线观看 · 内容仅为产品演示，版权归原权利人所有。</p>
          <p className="font-label tracking-wide">
            本站不存储任何视频文件 · 建议 18 岁以上用户浏览
          </p>
        </div>
      </div>
    </footer>
  );
}